<template>
    <v-dialog-old ref="dialog" @hidden="resetData()">
        <form>
            <fieldset>
                <legend>
                    {{ title }}
                    ({{ checked.length }}/{{ checkedMax }})
                </legend>

                <label v-for="option in filteredOptions">
                    <input type="checkbox"
                        v-model="checked"
                        :value="option.value"
                        :class="{'level2': option.level === '2'}"
                        :disabled="checked.length >= checkedMax && !checked.includes(option.value)"/>

                    <span>{{ option.text }}</span>
                </label>
            </fieldset>
        </form>

        <template v-slot:footer>
            <button class="green" @click="acceptChanges">Подтвердить</button>
        </template>
    </v-dialog-old>
</template>

<script>
export default {
    name: "DialogClinicTypes",

    props: {
        typeOptions: {
            type: Array,
            required: true
        },

        proprietary: {
            type: String,
            required: true
        },
    },

    data: function () {
        return {
            checked: this.$attrs.value,
        };
    },

    methods: {
        resetData() {
            this.checked = this.$attrs.value;
        },
        acceptChanges: function () {
            this.$emit('input', this.checked)
            this.$nextTick(() => {
                this.resetData();
                this.$refs.dialog.hide();
            });
        }
    },

    computed: {
        isMunicipal: function () {
            return this.proprietary === "municipal";
        },

        expectedProprietary: function () {
            return this.isMunicipal ? "MUNICIPAL" : "PRIVATE";
        },

        title: function () {
            return this.isMunicipal ? "Государственная" : "Частная";
        },

        filteredOptions: function () {
            return this.typeOptions.filter(value => value.proprietary === this.expectedProprietary);
        },

        checkedMax: function () {
            return 5;
        },
    },
    watch: {
        '$attrs.value': {
            immediate: false,
            handler(newValue) {
                this.checked = newValue;
            }
        },
    }
}
</script>
